var amdi18n={"__root":{"cloud_identity":"Cloud Identity","derived_from":"derived from","to_mobile":"Transfer to your Mobile","to_local":"But rather use on this computer"},"__de":{"cloud_identity":"Cloud Identität","derived_from":"abgeleitet von","to_mobile":"An ein Mobiltelefon übertragen","to_local":"Doch lieber an diesem Rechner nutzen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityView_strings.js
// module id = 99
// module chunks = 1